import React from 'react';
import { Card } from 'react-bootstrap';
import projectimage7 from "../../assets/img/np7.png";
import projImg7 from "../../assets/img/n7.png";
import ShowMoreText from "react-show-more-text";

const Card7 = () => {
    // Your component logic goes here

    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Quantifying scientific impact with correction for citation gaming</h2></Card.Title> */}

        <Card.Img variant="top" src={projectimage7} />

        <Card.Body>
          <Card.Text>
            {" "}
            <img className="img2" src={projImg7} />{" "}
            <p className="text7">Róbert Somogyi</p>
            <br />
            <p className="text8">
              Assistant Professor
              <br /> Department of Finance, BME
            </p>
          </Card.Text>
          <ShowMoreText lines={2}>
            <div>
              In the past decade, digital platforms have become widespread
              in the economy in general, and in finance in particular.
              These intermediaries connect two distinct groups of agents
              (e.g., buyers and sellers), taking advantage of the positive
              cross-group externalities between them. For instance, Visa
              became one of the largest financial services firms by
              connecting merchants to cardholders. Many policy-relevant
              questions arise about the optimal pricing structure of such
              firms, how they differ from traditional players in their
              sector, how their practices affect social welfare, and
              whether and how authorities should regulate them. Game
              theory and industrial economics offer a toolbox very well
              adapted to studying such regulatory issues.
              <br />
              <br />
            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default Card7;
